<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class=" d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"/>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-2">
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto">
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2">
            Bem-Vindo!
          </b-card-title>
          <b-card-text class="mb-2">
            Entrar na sua conta
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login">
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email">

                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="MailIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="john@example.com"/>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                  <b-link :to="{name:'forgot-password'}">
                    <small>Esqueceu a senha?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required">
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="LockIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"/>
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"/>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1">
                  Lembre-se de mim
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid">
                Entrar
              </b-button>

              <recaptcha-notice />
            </b-form>
          </validation-observer>

          <!-- Entrar com o Google. Serve para quem já tem conta e para quem não tem:
               o backend responde qual dos dois é. Contas administrativas são
               recusadas de propósito e seguem entrando por e-mail e senha. -->
          <google-sign-in-button
            text="signin_with"
            :busy="googleBusy"
            @credential="handleGoogleCredential"
          />

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GoogleSignInButton from '@/components/GoogleSignInButton.vue'
import RecaptchaNotice from '@/components/RecaptchaNotice.vue'
import recaptchaMixin from '@/mixins/recaptcha'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    RecaptchaNotice,
    GoogleSignInButton,
  },
  mixins: [togglePasswordVisibility, recaptchaMixin],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      googleBusy: false,
      sideImg: require('@/assets/images/logo/logo.png'),

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
  },
  methods: {
    /**
     * O Google devolveu um ID token. Se isso é login ou início de cadastro quem
     * decide é o backend — a tela não precisa saber.
     */
    handleGoogleCredential(idToken) {
      if (this.googleBusy) return

      if (this.$store.state.auth.isUserLoggedIn()) {
        this.notifyError(this.$vs, 'Não é possível utilizar mais que um usuário ao mesmo tempo.', 1500)
        return
      }

      this.googleBusy = true
      this.$vs.loading()

      localStorage.removeItem('userInfo')

      this.$store.dispatch('auth/socialLogin', {
        idToken,
        vs: this.$vs,
        acl: this.$acl,
        closeAnimation: () => {
          this.googleBusy = false
          this.$vs.loading.close()
        }
      })
    },

    login() {
      this.$refs.loginForm.validate().then(async success => {
        if (success) {
          this.clearErrors(this.$refs.loginForm)
          this.$vs.loading()

          const recaptchaToken = await this.getRecaptchaToken('login')

          const payload = {
            updateUsername: true,
            checkbox_remember_me: this.checkbox_remember_me,
            userDetails: {
              email: this.userEmail,
              password: this.password,
              recaptcha_token: recaptchaToken
            },
            vs: this.$vs,
            closeAnimation: this.$vs.loading.close,
            acl: this.$acl
          }

          if (this.$store.state.auth.isUserLoggedIn()) {
            this.$vs.loading.close()
            this.notifyError(this.$vs, 'Não é possível utilizar mais que um usuário ao mesmo tempo.', 1500)
            setTimeout(() => this.$router.go(), 2000)
          } else {
            localStorage.removeItem('userInfo')
            this.$store.dispatch('auth/loginAttempt', payload)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
